import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from './group-data-store.reducer';
import { GroupState } from './group-data-store.interface';

export const selectGroupState = createFeatureSelector<GroupState>(featureKey);

export const selectCompanyGroups = createSelector(selectGroupState, state => state?.companyGroups);
export const selectGroupLoadingState = createSelector(selectGroupState, state => state?.isLoading);
